import { AnonymousScreen } from '../screens/anonymousScreen';
import { MajorError } from './majorError';

const AppError = (props) => {
  const { message, action, actionTitle, error } = props;

  return (
    <AnonymousScreen>
      <MajorError
        message={message}
        error={error}
        action={action}
        actionTitle={actionTitle}
      />
    </AnonymousScreen>
  );
};

export { AppError };
